import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

interface ExtendOrganizationTrialParams {
  organizationId: string;
  /** ISO date-time: the end of the chosen local day. */
  trialEndsAt: string;
}

export const useExtendOrganizationTrial = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ organizationId, trialEndsAt }: ExtendOrganizationTrialParams) =>
      subscriptionService.extendOrganizationTrial(organizationId, trialEndsAt),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast.success(tActionMessages.trialExtendedSuccessfully);
    },
    onError: (error: any) => {
      // The server message names the cause (past date, NMI-backed, wrong status), so show it verbatim.
      toast.error(
        error?.response?.errors?.[0]?.message ||
          tActionMessages.failedToExtendTrial,
      );
    },
  });
};
